// LocationDialog — Presentational modal asking the user where to search
// (near airport vs. near hotel). Composes LocationDialogOption.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icon, text, and the overlay/stop-propagation click handlers are identical to
// the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { X } from 'lucide-react';
import { LocationDialogOption } from './LocationDialogOption';

export const LocationDialog = React.memo(function LocationDialog({ location, hasHotel, selectedHotel, onSelect, onClose }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
            Where would you like to search?
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '4px', display: 'flex', alignItems: 'center', color: '#6b7280'
            }}
          >
            <X size={20} />
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {location && (
            <LocationDialogOption
              emoji="✈️"
              title="Near Airport"
              subtitle={location.airportCode || location.address || 'Airport location'}
              onSelect={() => onSelect('airport')}
            />
          )}
          {hasHotel && (
            <LocationDialogOption
              emoji="🏨"
              title="Near Hotel"
              subtitle={selectedHotel.name}
              onSelect={() => onSelect('hotel')}
            />
          )}
        </div>
      </div>
    </div>
  );
});

export default LocationDialog;
